<template>
  <main id="main" class="main-site left-sidebar">
    <div class="container">
      <Breadcrumb :pages="breadcrumbPages" />

      <div class="row mob-flexbox-column-reverse">
        <div class="col-lg-9 col-md-8 col-sm-8 col-xs-12 main-content-area">
          <div v-if="dadosSegmento && dadosSegmento.UrlImagem" class="row" style="margin-bottom: 25px">
            <AlertCompletarCadastro v-if="session" :visible="situacaoCadastro == 1" :cnpj="session.DadosCliente.CliCiccgc"></AlertCompletarCadastro>

            <AlertCadastroNaoAtivo v-if="session" :visible="situacaoCadastro == 2"></AlertCadastroNaoAtivo>
          </div>
          <div class="row" v-if="this.$route.params.pathMatch">
            <div class="col-md-12">
              <div class="filters">
                <div class="filter" v-for="(item, index) in filtros" :key="index">
                  <a rel="nofollow" @click="updateLocalStorage(filtros[0])" v-if="index == 0" :href="`${$SiteUrl}/loja/` + menu + '/' + filtros[0]"
                    >X</a
                  >
                  <a
                    rel="nofollow"
                    @click="updateLocalStorage(filtros.slice(0, index).join('/'))"
                    v-else
                    :href="`${$SiteUrl}/loja/` + menu + '/' + filtros.slice(0, index).join('/')"
                    >X</a
                  >
                  <span>{{ item.replace(/-/g, ' ').toUpperCase() }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div class="wrap-shop-control">
            <h1 class="shop-title" v-if="breadcrumbPages">
              {{ actualCategory.name }}
            </h1>
            <span>
              <div class="wrap-right">
                <div class="text-info pull-left text-right total-exibido h5" v-show="products.length > 0">
                  <small>Exibindo </small>{{ products.length }}<small> de </small>{{ this.totalRegistros }}
                </div>
                <div class="sort-item orderby">
                  <select name="orderby" class="use-chosen" @change="onChangeOrdenacao($event)" v-model="order">
                    <option value="1">Menor preço</option>
                    <option value="-1">Maior preço</option>
                    <option v-if="filtroPotencia" value="3">Menor Potência</option>
                    <option v-if="filtroPotencia" value="4">Maior Potência</option>
                    <option value="2">Mais Vendidos</option>
                  </select>
                </div>
              </div>
            </span>
          </div>

          <!--end wrap shop control-->
          <br />
          <div class="row shoplist">
            <ul>
              <div class="col-md-4" v-for="(product, index) in products" :key="index">
                <div class="row width-100">
                  <div :class="['top-sales-star', 'top-sales-star-' + (index + 1)]" v-if="moreSales && index < 3"></div>
                  <Product :product="product" />
                </div>
              </div>
            </ul>
          </div>

          <Loader v-if="loadingProducts" />
          <div
            v-show="
              !loadingProducts && menu != 'home' && this.totalRegistros > 0 && this.products.length > 0 && this.products.length < this.totalRegistros
            "
            class="row"
          >
            <div class="col-md-4"></div>
            <div class="col-md-4 col-only-button">
              <div class="text-center">
                <button aria-label="Carregar Mais" class="btn primary-button stretch" v-on:click.prevent="loadMore()">
                  <strong>Carregar Mais</strong>
                </button>
              </div>
            </div>
            <div class="col-md-4"></div>
          </div>

          <div class="col-md-12" style="padding: 0">
            <div v-if="dadosSegmento && dadosSegmento.DescricaoCategoria">
              <button aria-label="Leia Mais" v-on:click="onClickDiv" class="btnExpandTextArea">
                {{ btnExpand }}
              </button>
              <div id="textAreaID" :class="isActive && textAreacustom" contenteditable="false" v-html="dadosSegmento.DescricaoCategoria"></div>
            </div>
          </div>
        </div>
        <!--end main products area-->

        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12 sitebar">
          <product-filters v-if="menu != 'home'" :category="category" :itemsFiltro="itemsFiltro"></product-filters>
          <!-- brand widget-->
        </div>
        <!--end sitebar-->
      </div>
      <!--end row-->
    </div>
    <!--end container-->
  </main>
</template>

<script>
import Breadcrumb from '../../components/partials/Breadcrumb.vue'
import Product from '../../components/partials/Product.vue'
import ProductFilters from '../../components/partials/ProductFilters.vue'
import Loader from '../../components/partials/Loader.vue'
import AlertCompletarCadastro from '../../components/partials/AlertCompletarCadastro'
import AlertCadastroNaoAtivo from '../../components/partials/AlertCadastroNaoAtivo'

export default {
  name: 'ProductsList',
  metaInfo() {
    const route = this.$route
    const _self = this
    var url = 'https://www.aldo.com.br'
    url = `${url}${_self.$route.path.replace('/loja', '')}`
    url = '0; url=' + url
    var redirectURL = _self.$route.path.toString().toUpperCase().indexOf('/LOJA/CATEGORIA/') >= 0 ? true : false
    if (localStorage.getItem('usuarioLogado') === null && localStorage.getItem('waitingLogin') === null && redirectURL) {
      return {
        meta: [{ 'http-equiv': 'refresh', content: url }],
      }
    } else {
      return {
        title: _self.dadosSegmento.MetaTitle,
        meta: [
          { name: 'description', content: _self.dadosSegmento.MetaDescription },
          {
            name: 'twitter:card',
            content: _self.dadosSegmento.MetaDescription,
          },
          { name: 'twitter:title', content: _self.dadosSegmento.MetaTitle },
          {
            name: 'twitter:description',
            content: _self.dadosSegmento.MetaDescription,
          },
          // image must be an absolute path
          {
            name: 'twitter:image',
            content: 'https://www.aldo.com.br/assets/images/logo-top-1.png',
          },
          // Facebook OpenGraph
          { property: 'og:title', content: _self.dadosSegmento.MetaTitle },
          { property: 'og:site_name', content: 'Aldo Solar' },
          { property: 'og:locale', content: 'pt_BR' },
          { property: 'og:type', content: 'website' },
          {
            property: 'og:image',
            content: 'https://www.aldo.com.br/assets/images/logo-top-1.png',
          },
          {
            property: 'og:description',
            content: _self.dadosSegmento.MetaDescription,
          },
        ],
        link: [
          {
            rel: 'canonical',
            href: `${_self.$SiteUrl}${route.path.replace('/', '')}`,
          },
        ],
      }
    }
  },
  mounted() {
    const logon = localStorage.getItem('usuarioLogado')
    if (logon) {
      this.session = JSON.parse(logon)
      this.situacaoCadastro = this.session.DadosCliente.SituacaoCadastro
    }

    var menu = this.$route.path.split('/')[2]

    this.menu = menu

    if (menu === 'home') {
      var endPoint = ''

      if (this.$route.params.name === 'mais-vendidos') {
        endPoint = 'getprodutostopvendas/true/false'
        this.moreSales = true
      } else {
        endPoint = 'getprodutoslancamentos'
      }

      var xhr = new XMLHttpRequest()

      xhr.onload = () => {
        if (xhr.status == 200) {
          let produtos = JSON.parse(xhr.responseText)

          produtos.forEach((element) => {
            let produto = {}
            produto.id = element.PRD_CODIGO
            produto.code = element.PRD_CODIGO + '-' + element.PRD_CODIGODV
            produto.name = element.PSG_DESCRICAO + ' ' + element.PGR_DESCRICAO
            produto.state = 'PR'
            produto.img = element.PRD_CAMINHO
            produto.description = element.PRD_DESCRICAO
            produto.potencia = element.PRD_POTENCIA

            const productDesc =
              produto.name
                .replace(/\s+/g, '-')
                .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
                .toLowerCase() +
              '-' +
              element.PRD_DESCRICAO.trim()
                .replace(/\s+/g, '-')
                .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
                .toLowerCase()

            produto.url = '/loja/produto/' + produto.code + '/' + productDesc
            produto.price = element.PRECOPRODUTO
            produto.showActions = true
            produto.isLogged = element.IS_LOGGED
            produto.prdQtdeUnidade = element.PRD_QTDEUNID
            this.products.push(produto)
          })

          this.loadingProducts = false
        }
      }

      xhr.open('GET', this.$apiUrl + 'Produto.svc/' + endPoint)
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true
      xhr.send()
    }

    this.mountBreadcrumb()
  },
  watch: {
    order: function () {
      this.offset = 0
      this.clearProducts = true
      this.loadProducts()
    },
  },
  data() {
    return {
      breadcrumbPages: [
        // { name: "Home", link: "/loja" },
        // { name: "Categorias", link: "/categorias" },
        // { name: this.beautifyUrl(this.$route.params.name) }
      ],
      moreSales: false,
      clearProducts: true,
      loadingProducts: true,
      menu: this.$route.params.menu,
      filtros: [],
      products: [],
      category: {},
      offset: 0,
      actualCategory: '',
      order: 1,
      filterId: 0,
      totalRegistros: 0,
      slug: '',
      dadosSegmento: {},
      leiaMais: false,
      filtroPotencia: false,
      isActive: true,
      textAreacustom: 'textAreacustom',
      btnExpand: '+',
      itemsFiltro: [],
      situacaoCadastro: 0,
      session: null,
    }
  },
  components: {
    Breadcrumb,
    Product,
    ProductFilters,
    Loader,
    AlertCompletarCadastro,
    AlertCadastroNaoAtivo,
  },
  methods: {
    onChangeOrdenacao(event) {
      this.orderby = event.target.value
    },
    onClickDiv() {
      if (this.isActive) {
        this.btnExpand = '-'
        this.isActive = false
      } else {
        this.isActive = true
        this.btnExpand = '+'
      }
    },
    mountBreadcrumb: function () {
      this.breadcrumbPages.push({
        name: 'Home',

        link: '/loja',
      })
      var slug = this.$route.params.pathMatch !== undefined ? this.$route.params.name + this.$route.params.pathMatch : this.$route.params.name

      let filtros = slug.split(new RegExp('/'))

      for (let index = 0; index < filtros.length; index++) {
        const element = filtros[index].replace(/-/g, ' ').toUpperCase()
        this.breadcrumbPages.push({
          name: element,
          link: this.linkAnterior(index, filtros),
        })
      }

      if (filtros.find((element) => element == 'energia-solar') != null) {
        this.filtroPotencia = true
      } else {
        this.filtroPotencia = false
      }
      this.actualCategory = this.breadcrumbPages[this.breadcrumbPages.length - 1]
    },
    linkAnterior: function (i, arr) {
      var menu = this.$route.path.split('/')[2]

      let link = this.$SiteUrl + '/loja/' + menu
      for (let index = 0; index <= i; index++) {
        link += '/' + arr[index]
      }
      return link
    },
    beautifyUrl: function (url) {
      url = url.replace('-', ' ')
      url = url.charAt(0).toUpperCase() + url.slice(1)

      return url
    },
    beautifyUrl2: function (url) {
      if (url != undefined) {
        url = url.split('-').join(' ')
        url = url.split('/').join(' ')
        url = url.charAt(0).toUpperCase() + url.slice(1)
        return url.toUpperCase()
      } else {
        return 'HOME'
      }
    },
    updateLocalStorage: function (slugNovo) {
      localStorage[slugNovo] = ''

      // let termo = localStorage[this.slug]
      // localStorage[slugNovo] = termo
    },
    updateFilterId: function (value) {
      this.filterId = value
    },
    updateTotalRegistros: function (totalRegistros) {
      this.totalRegistros = totalRegistros
    },
    loadMore: function () {
      this.offset += 1
      this.clearProducts = false

      this.loadProducts()
    },
    clearOffSet: function () {
      this.offset = 0
      this.clearProducts = true
    },
    loadProducts: function () {
      const session = JSON.parse(localStorage.getItem('usuarioLogado'))
      this.loadingProducts = true

      if (this.clearProducts) this.products = []

      const menu = this.$route.path.split('/')[2]
      this.menu = menu

      if (menu !== 'home') {
        const url = new URL(location.href)
        const filtro = url.searchParams.get('filtro')

        const xhr = new XMLHttpRequest()

        const slug = this.$route.params.pathMatch !== undefined ? this.$route.params.name + this.$route.params.pathMatch : this.$route.params.name

        this.slug = slug

        let termo = ''
        if (localStorage[slug] != 'undefined') {
          termo = localStorage[slug]
        } else {
          termo = localStorage.getItem('termo_pesquisa')
        }

        const filtros = slug.split(new RegExp('/'))

        this.filtros = filtros

        xhr.onload = () => {
          if (xhr.status == 200) {
            const res = JSON.parse(xhr.responseText)

            const filtro = res.Filtros

            if (this.itemsFiltro.length == 0) this.itemsFiltro = filtro.Dados

            this.updateTotalRegistros(filtro.TotalRegistros)

            let produtos = res.Produtos

            produtos.forEach((element) => {
              let produto = {}
              produto.id = element.produto_id
              produto.code = element.produto_id + '-' + element.prd_codigodv
              produto.name = element.psg_descricao + ' ' + element.pgr_descricao
              produto.state = 'PR'
              produto.img = element.prd_caminho
              produto.description = element.prd_descricao
              produto.url = '/loja/produto/' + produto.code + '/' + element.URL
              produto.promotionalPrice = element.prd_precode
              produto.price = element.prd_preco
              produto.showActions = true
              produto.isLogged = element.is_logged
              produto.prdQtdeUnidade = element.prd_qtdeUnid
              produto.qtd = element.prd_qtdeUnid
              produto.productSelos = element.Selos
              produto.potencia = element.potencia > 0 ? element.prd_preco / (element.potencia * 1000) : 0
              produto.gerador = element.gerador
              produto.wallbox = element.wallbox
              produto.potenciaGerador = element.prd_potenciaGerador
              produto.potenciaInversor = element.prd_potenciaInversor
              produto.mppt = element.prd_mppt
              produto.tensao = element.prd_tensao
              produto.fase = element.prd_fase
              produto.suframa = session ? session.DadosCliente.IsSuframa : ''
              produto.valorParcela = element.prd_valorParcela

              this.products.push(produto)
            })

            this.carregaDataLayer(produtos)
          }
          this.loadingProducts = false
        }

        xhr.open('POST', this.$apiUrl + 'Produto.svc/getfiltroeprodutosporsegmento')
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.withCredentials = true

        if (menu === 'busca') {
          xhr.send(
            JSON.stringify({
              slug: slug,
              pTermo: termo,
              origem: 'busca',
              idAcionado: localStorage.idAcionado,
              filtroAtributos: filtro,
              offset: this.offset,
              orderby: this.order,
            })
          )
        } else if (menu === 'campanha') {
          xhr.send(
            JSON.stringify({
              slug: slug,
              origem: 'busca',
              codigoCampanha: localStorage.idCampanha,
              idAcionado: localStorage.idAcionado,
              filtroAtributos: filtro,
              offset: this.offset,
              filterId: this.filterId,
              orderby: this.order,
            })
          )
        } else if (menu === 'marca') {
          xhr.send(
            JSON.stringify({
              slug: slug,
              origem: 'busca',
              codigoMarca: localStorage.idMarca,
              marcaTipoAba: 'T',
              idAcionado: localStorage.idAcionado,
              filtroAtributos: filtro,
              offset: this.offset,
              filterId: this.filterId,
              orderby: this.order,
            })
          )
        } else {
          xhr.send(
            JSON.stringify({
              slug: slug,
              origem: 'categoria',
              idAcionado: localStorage.idAcionado,
              filtroAtributos: filtro,
              offset: this.offset,
              filterId: this.filterId,
              orderby: this.order,
            })
          )
        }

        this.getDadosSegmento()
      }
    },
    getDadosSegmento() {
      let xhr = new XMLHttpRequest()

      xhr.open('POST', this.$apiUrl + 'Produto.svc/GetDadosSegmento')
      xhr.setRequestHeader('Content-type', 'application/json')

      xhr.onload = () => {
        if (xhr.status == 200) {
          this.dadosSegmento = JSON.parse(xhr.responseText)
        }
      }

      xhr.send(
        JSON.stringify({
          slug: this.slug,
          origem: this.menu,
        })
      )
    },
    carregaDataLayer(value) {
      if (dataLayer) {
        dataLayer.push({ ecommerce: null })
        dataLayer.push({
          event: 'view_item_list',
          ecommerce: {
            items: value.map((x, i) => ({
              item_name: x.prd_descricao,
              item_id: `${x.produto_id}-${x.prd_codigodv}`,
              price: x.prd_preco,
              item_brand: x.psg_descricao,
              index: i,
              quantity: 1,
            })),
          },
        })
      }
    },
  },
}
</script>
